import React from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Button,
} from 'reactstrap';
import { PLANS } from '../../config/settings';

const Pricing = () => {
  return (
    <section id="pricing" className="pricing">
      <Container>
        <h2 className="text-center mb-5">Scegli il tuo piano di abbonamento</h2>
        <Row className="justify-content-center">
          {PLANS.map((plan, index) => (
            <Col md={6} lg={5} key={index} className="mb-4">
              <Card
                className={`pricing-card ${
                  plan.highlighted ? 'pricing-card--highlighted' : ''
                }`}>
                <CardHeader>
                  <h3>{plan.title}</h3>
                  <div className="pricing-subtitle">{plan.subtitle}</div>
                  <p>{plan.description}</p>
                </CardHeader>
                <CardBody>
                  <div className="pricing-price">
                    {plan.promoPrice && (
                      <>
                        <div className="promo-label">Prezzo</div>
                        <div className="price-container">
                          <span className="original-price">
                            <span className="currency">€</span>
                            {plan.price}
                          </span>
                        </div>
                        <div className="promo-label highlighted">
                          Prezzo lancio
                        </div>
                        <div className="price-container">
                          <span className="promo-price">
                            <span className="currency">€</span>
                            {plan.promoPrice}
                            <span className="period">/{plan.periodLabel}</span>
                          </span>
                        </div>
                        {plan.discountPercentage && (
                          <div className="discount-percentage">
                            Risparmia il {plan.discountPercentage}% rispetto al
                            prezzo mensile
                          </div>
                        )}
                      </>
                    )}
                    {!plan.promoPrice && (
                      <div className="price-container">
                        <span className="promo-price">
                          <span className="currency">€</span>
                          {plan.price}
                          <span className="period">/{plan.periodLabel}</span>
                        </span>
                      </div>
                    )}
                  </div>
                  <ul className="pricing-features">
                    {plan.features.map((feature, idx) => (
                      <li key={idx}>{feature}</li>
                    ))}
                  </ul>
                  <Button
                    color="primary"
                    size="lg"
                    block
                    onClick={() => {
                      window.location.href = '/register';
                    }}>
                    Inizia
                  </Button>
                </CardBody>
              </Card>
            </Col>
          ))}
        </Row>
      </Container>
    </section>
  );
};

export default Pricing;
